import { useCallback } from 'react';
import { selectUser } from '../../common/store/slices/auth.slice';

import { useAppSelector } from '../../common/hooks/redux';
import { isLocalhost } from './utils';
import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';

declare global {
  interface Window {
    FS: any;
  }
}

export const useFullStory = () => {
  const user = useAppSelector(selectUser);
  const { activeProject } = useModuleProjectContext();

  const initiateFullStory = useCallback(() => {
    if (user.id && user.companyName && !isLocalhost()) {
      const { FS } = window;
      if (FS) {
        FS('setIdentity', {
          uid: user.id,
          properties: {
            displayName: user.externalName,
            email: user.email,
            userId: user.id,
            projectClientName: activeProject?.projectClientName ?? 'unknown',
            projectDisplayName: activeProject?.projectDisplayName ?? 'unknown',
            companyName: user.companyName,
          },
        });
      }
    }
  }, [user, activeProject]);

  return { initiateFullStory };
};
